import React from "react"

function getAvailabilityStatus(days) {
  if (days === 0) {
    return { status: "Expire Today", isExpired: false }
  } else if (days === 1) {
    return { status: "Expire Tomorrow", isExpired: false }
  } else {
    return {
      status: `Expire${1 < days ? "s" : ""} in ${days} day(s)`,
      isExpired: false,
    }
  }

  // if (days < 7) {
  //   return { status: `Available for ${days} Days`, isExpired: false }
  // }

  // if (days < 30) {
  //   const weeks = Math.floor(days / 7)
  //   const extraDays = days % 7
  //   let status = `Available for ${weeks} Week${weeks > 1 ? "s" : ""}`
  //   if (extraDays > 0) {
  //     status += ` and ${extraDays} Day${extraDays > 1 ? "s" : ""}`
  //   }
  //   return { status, isExpired: false }
  // }

  // if (days < 365) {
  //   const months = Math.floor(days / 30)
  //   const extraDays = days % 30
  //   let status = `Available for ${months} Month${months > 1 ? "s" : ""}`
  //   if (extraDays > 0) {
  //     status += ` and ${extraDays} Day${extraDays > 1 ? "s" : ""}`
  //   }
  //   return { status, isExpired: false }
  // }

  // const years = Math.floor(days / 365)
  // const extraDays = days % 365
  // let status = `Available for ${years} Year${years > 1 ? "s" : ""}`

  // if (extraDays > 0) {
  //   // recursively call function for remainder
  //   const extra = getAvailabilityStatus(extraDays)
  //   status += ` and ${extra.status.replace("Available for ", "")}`
  // }

  // return { status, isExpired: false }
}
function ExpiredFormat({ value = "", dataItem = {} }) {
  let { status = "", isExpired = false } =
    getAvailabilityStatus(Number(value)) || {}

  const { is_active = false } = dataItem
  console.log("dataItem", dataItem)
  return (
    <>
      {is_active ? (
        <div
          style={{
            fontSize: 13,
            color: isExpired ? "red" : "green",
            fontWeight: "bold",
          }}
        >{`${status}`}</div>
      ) : (
        <></>
      )}
    </>
  )
}

export default ExpiredFormat
export { ExpiredFormat }
